import { createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  container: {
    height: '35px',
    minWidth: '100%',
    marginTop: '2px'
  }
});
